import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

interface Activity {
  nome: string;
  email: string;
  tipo_do_evento: string;
  created_at: string;
}

export function useRecentActivity() {
  const [activities, setActivities] = useState<Activity[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchActivities = async () => {
    try {
      setLoading(true);
      setError(null);
      console.log('🔍 Buscando atividades recentes...'); 

      // Primeiro, vamos verificar se a tabela tem dados
      const { count, error: countError } = await supabase
        .from('acm_novo_usuario')
        .select('*', { count: 'exact', head: true });

      if (countError) {
        console.error('❌ Erro ao contar registros:', countError);
        throw countError;
      }

      console.log('📊 Total de registros na tabela:', count);

      // Busca os dados com debug
      const { data, error: fetchError } = await supabase
        .from('acm_novo_usuario')
        .select('*')
        .order('created_at', { ascending: false })
        .limit(5);

      if (fetchError) {
        console.error('❌ Erro na query:', fetchError);
        throw fetchError;
      }

      console.log('📦 Dados brutos recebidos:', data);

      if (!data || data.length === 0) {
        console.warn('⚠️ Nenhum dado recebido');
        setActivities([]);
        return;
      }

      // Mapeia os dados para o formato esperado
      const formattedActivities = data.map(item => {
        console.log('🔄 Processando item:', item);
        return {
          nome: item.nome || 'Nome não disponível',
          email: item.email || '',
          tipo_do_evento: item.tipo_do_evento || 'Tipo não especificado',
          created_at: item.created_at || new Date().toISOString()
        };
      });

      console.log('✨ Dados formatados:', formattedActivities);
      setActivities(formattedActivities);
    } catch (err) {
      console.error('❌ Erro ao buscar atividades:', err);
      setError(err instanceof Error ? err.message : 'Erro ao carregar atividades');
      setActivities([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchActivities();

    // Inscreve-se para atualizações em tempo real
    const channel = supabase
      .channel('acm_novo_usuario_changes')
      .on('postgres_changes', {
        event: '*',
        schema: 'public',
        table: 'acm_novo_usuario'
      }, (payload) => {
        console.log('🔔 Nova atividade recebida:', payload);
        fetchActivities();
      })
      .subscribe((status) => {
        console.log('📡 Status da subscription:', status);
      });

    return () => {
      channel.unsubscribe();
    };
  }, []);

  return {
    activities,
    loading,
    error,
    refresh: fetchActivities
  };
}